import React from 'react'
export default () => {
  return (
    <div>
        <div className="site-content h-100">
  <div className="p-4">
    <div className="site-content-body">
      {/*-----------------------------
     Start || invoices section
     ----------------------------- */}
      <section className="payment-sec main-sec">
        <div className="container">
          <form action>
            {/* ---------Invoices TABLE------- */}
            <div className="input-main my-2">
              <div className="py-2 px-2 d-flex justify-content-between search-invoice-main">
                <div className="d-flex align-items-center bg-white rounded-pill px-2 search-invoice me-3">
                  <label htmlFor="search"><i className="fas fa-search me-2" /></label>
                  <input type="search" placeholder="Search..." className="w-100 bg-transparent border-0 py-1" id="search" />
                </div>
                {/* ----------Dropdown----- */}
                <div className="dropdown">
                  <a className="d-flex align-items-center bg-white rounded-pill px-2 py-2 sort-main btn  dropdown-toggle" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                    <span className="me-2 fw-bolder">Sort</span>
                    <i className="bi bi-list-nested" />
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <li><a className="dropdown-item "  style={{color:"#005E9D"}} href="#">Oldest</a></li>
                    <li><a className="dropdown-item "  style={{color:"#005E9D"}} href="#">Newest</a></li>
                    <li><a className="dropdown-item "  style={{color:"#005E9D"}} href="#">Paid</a>
                    </li>
                    <li><a className="dropdown-item "  style={{color:"#005E9D"}} href="#">Days Overdue</a></li>
                    <li><a className="dropdown-item "  style={{color:"#005E9D"}} href="#">Price
                        (high)</a></li>
                    <li><a className="dropdown-item "  style={{color:"#005E9D"}} href="#">Price
                        (low)</a></li>
                  </ul>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="fw-bolder">Due Date</th>
                      <th className="fw-bolder">Invoice #</th>
                      <th className="fw-bolder">Amount</th>
                      <th className="fw-bolder">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>11/20/22</td>
                      <td>#324567</td>
                      <td>$200.0</td>
                      <td>
                        <div className="d-flex justify-content-between">
                          <span className="bg-success py-1 rounded-circle text-dark d-flex justify-content-center align-items-center invoice-circle border border-dark fw-bolder" />
                          <span>Paid</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>11/25/22</td>
                      <td>#654783</td>
                      <td>$250.0</td>
                      <td>
                        <div className="d-flex justify-content-between">
                          <span className="bg-danger py-1 rounded-circle text-dark d-flex justify-content-center align-items-center invoice-circle border border-dark fw-bolder">7</span>
                          <span>Days Overdue</span>
                        </div>
                      </td>
                    </tr>
                    {/* <tr>
                      <td>11/20/22</td>
                      <td>#324567</td>
                      <td>$200.0</td>
                      <td>
                        <div className="d-flex justify-content-between">
                          <span className="bg-warning py-1 rounded-circle text-dark d-flex justify-content-center align-items-center invoice-circle border border-dark fw-bolder" />
                          <span>Pending</span>
                        </div>
                      </td>
                    </tr> */}
                    <tr>
                      <td>11/25/22</td>
                      <td>#654783</td>
                      <td>$250.0</td>
                      <td>
                        <div className="d-flex justify-content-between">
                          <span className="bg-danger py-1 rounded-circle text-dark d-flex justify-content-center align-items-center invoice-circle border border-dark fw-bolder">10</span>
                          <span>Days Overdue</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>11/20/22</td>
                      <td>#324567</td>
                      <td>$200.0</td>
                      <td>
                        <div className="d-flex justify-content-between">
                          <span className="bg-success py-1 rounded-circle text-dark d-flex justify-content-center align-items-center invoice-circle border border-dark fw-bolder" />
                          <span>Paid</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>11/25/22</td>
                      <td>#654783</td>
                      <td>$250.0</td>
                      <td>
                        <div className="d-flex justify-content-between">
                          <span className="bg-danger py-1 rounded-circle text-dark d-flex justify-content-center align-items-center invoice-circle border border-dark fw-bolder">20</span>
                          <span>Days Overdue</span>
                        </div>
                      </td>
                    </tr>
                    {/* <tr>
                      <td>11/20/22</td>
                      <td>#324567</td>
                      <td>$200.0</td>
                      <td>
                        <div className="d-flex justify-content-between">
                          <span className="bg-warning py-1 rounded-circle text-dark d-flex justify-content-center align-items-center invoice-circle border border-dark fw-bolder" />
                          <span>Pending</span>
                        </div>
                      </td>
                    </tr> */}
                    <tr>
                      <td>11/25/22</td>
                      <td>#654783</td>
                      <td>$250.0</td>
                      <td>
                        <div className="d-flex justify-content-between">
                          <span className="bg-danger py-1 rounded-circle text-dark d-flex justify-content-center align-items-center invoice-circle border border-dark fw-bolder">15</span>
                          <span>Days Overdue</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>11/20/22</td>
                      <td>#324567</td>
                      <td>$200.0</td>
                      <td>
                        <div className="d-flex justify-content-between">
                          <span className="bg-success py-1 rounded-circle text-dark d-flex justify-content-center align-items-center invoice-circle border border-dark fw-bolder" />
                          <span>Paid</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>11/25/22</td>
                      <td>#654783</td>
                      <td>$250.0</td>
                      <td>
                        <div className="d-flex justify-content-between">
                          <span className="bg-danger py-1 rounded-circle text-dark d-flex justify-content-center align-items-center invoice-circle border border-dark fw-bolder">12</span>
                          <span>Days Overdue</span>
                        </div>
                      </td>
                    </tr>
                    <tr className="link">
                      <td colSpan={4} className="text-center">
                        <a href="#">Load more....</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </form>
        </div>
      </section>
      {/*-----------------------------
     End || invoices section
     ----------------------------- */}
    </div>
  </div>
</div>

    </div>
  )
}
